export const LabelText = {
  TITLE: 'Order report',
  EMPTY_PAGE_TITLE: 'All order records will show here',
  EMPTY_PAGE_SUBTITLE:
    'As your employees start placing orders through their corporate accounts, you will see all their orders with details here.',
  SUCCESS_MESSAGE: 'Report Downloaded',
  DOWNLOAD_BUTTON: 'Download',
  DOWNLOAD_EXCEL_BUTTON: 'Download Excel (.xlsx)',
  DOWNLOAD_CSV_BUTTON: 'Download CSV (.csv)',
  DOWNLOAD_SUBJECT: 'Report',
  TOOLTIP:
    'To download a report, please select a date range that is equal to or less than a month'
};

export const TestId = {
  csv: 'csvUpload',
  xlsx: 'xlsxUpload'
};
